import { render, staticRenderFns } from "./AddNotificationRecipientModalComponent.vue?vue&type=template&id=4f7239ea"
import script from "./AddNotificationRecipientModalComponent.vue?vue&type=script&lang=js"
export * from "./AddNotificationRecipientModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports